"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FlywireResult = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _composePaymentReference = _interopRequireDefault(require("@htmniseko/htm-helpers/flywire/composePaymentReference"));
var _getUrlQuery2 = _interopRequireDefault(require("@htmniseko/htm-helpers/url/getUrlQuery"));
var _PaymentContext = _interopRequireDefault(require("../../../context/PaymentContext"));
var _api = require("../../../utils/api");
var _Flywire = require("../../../components/Flywire");
var _Common = require("../../../components/Common");
var _browser = require("../../../browser");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null == arguments[r] ? {} : arguments[r]; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var FIVE_SECONDS = 5000;
var FlywireResult = exports.FlywireResult = function (_PureComponent) {
  function FlywireResult() {
    var _this;
    (0, _classCallCheck2["default"])(this, FlywireResult);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
    return _this = _callSuper(this, FlywireResult, [].concat(args)), (0, _defineProperty2["default"])(_this, "isMounted", false), ((0, _defineProperty2["default"])(_this, "state", {
      waiting: false,
      validated: false
    }), _this = _callSuper(this, FlywireResult, [].concat(args)), (0, _defineProperty2["default"])(_this, "isMounted", false), (0, _defineProperty2["default"])(_this, "state", {
      waiting: false,
      validated: false
    }), _this);
  }
  return (0, _inherits2["default"])(FlywireResult, _PureComponent), (0, _createClass2["default"])(FlywireResult, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.isMounted = true, this.handleFlywireCallbacks();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.isMounted = false;
    }
  }, {
    key: "handleFlywireError",
    value: function handleFlywireError(queries) {
      var _this$props = this.props,
        intl = _this$props.intl,
        onError = _this$props.onError;
      var message = intl.formatMessage({
        id: 'htmPayment.flywire.payment.error.message'
      });
      var error = new Error(message);
      error.queries = queries, onError(error);
    }
  }, {
    key: "handleFlywireCallbacks",
    value: function handleFlywireCallbacks() {
      var queries = (0, _getUrlQuery2["default"])();
      switch (queries.status) {
        case 'success':
          this.handlePaymentValidation(queries);
          break;
        case 'pending':
          this.handleFlywireError(queries);
          break;
        case 'cancel':
          this.handleFlywireError(queries);
          break;
        case 'error':
          this.handleFlywireError(queries);
          break;
        case 'failure':
          this.handleFlywireError(queries);
          break;
        default:
      }
    }
  }, {
    key: "handlePaymentValidation",
    value: function handlePaymentValidation(queries) {
      var _this2 = this;
      var _this$props2 = this.props,
        locale = _this$props2.intl.locale,
        validateUrl = _this$props2.validateUrl,
        onSuccess = _this$props2.onSuccess,
        onError = _this$props2.onError,
        onUnverified = _this$props2.onUnverified,
        tenantId = _this$props2.tenantId,
        guestSource = _this$props2.guestSource,
        guestId = _this$props2.guestId;
      var reference = queries.reference,
        tenantLabel = queries.tenantLabel,
        folioId = queries.folioId,
        sessionToken = queries.sessionToken,
        status = queries.status;
      var paymentReference = (0, _composePaymentReference["default"])(reference, tenantLabel, folioId);
      var configs = {
        url: validateUrl,
        method: 'post',
        params: {
          sessionId: sessionToken,
          paymentReference: paymentReference,
          paymentId: reference
        },
        locale: locale,
        tenantId: tenantId,
        guestSource: guestSource,
        guestId: guestId
      };
      this.setState({
        waiting: true
      }), setTimeout(function () {
        (0, _api.validateFlywirePayment)(configs, function (err, res) {
          if (err && status !== 'success') return _this2.setState({
            waiting: false
          }), void onError(err.response.body.error);
          if (_this2.isMounted) {
            if (_this2.setState({
              waiting: false
            }), res !== null && res !== void 0 && res.validated) return _this2.setState({
              validated: true
            }), void onSuccess(_objectSpread(_objectSpread({}, queries), res));
            if (status === 'success') return _this2.setState({
              validated: false
            }), void onUnverified();
            onError(new Error('Unable to validate response.'));
          }
        });
      }, FIVE_SECONDS);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        websiteUrls = _this$props3.websiteUrls,
        intl = _this$props3.intl,
        primaryTextColor = _this$props3.primaryTextColor;
      var _this$state = this.state,
        waiting = _this$state.waiting,
        validated = _this$state.validated;
      var _getUrlQuery = (0, _getUrlQuery2["default"])(),
        status = _getUrlQuery.status,
        reference = _getUrlQuery.reference;
      var locale = (intl === null || intl === void 0 ? void 0 : intl.locale) || 'en';
      var websiteUrl = websiteUrls[locale];
      return waiting ? _react["default"].createElement(_browser.Container, {
        margin: "small",
        minHeight: "250px"
      }, _react["default"].createElement(_Common.Loader, null)) : status === 'success' ? validated ? _react["default"].createElement(_Flywire.SuccessMessage, {
        reference: reference
      }) : _react["default"].createElement(_Flywire.UnderValidationMessage, {
        websiteUrl: websiteUrl,
        linkColor: primaryTextColor
      }) : status === 'pending' ? _react["default"].createElement(_Flywire.ErrorMessage, {
        reference: reference
      }) : status === 'cancel' ? _react["default"].createElement(_Flywire.ErrorMessage, {
        reference: reference
      }) : status === 'error' ? _react["default"].createElement(_Flywire.ErrorMessage, {
        reference: reference
      }) : status === 'failure' ? _react["default"].createElement(_Flywire.ErrorMessage, {
        reference: reference
      }) : _react["default"].createElement(_Flywire.ErrorMessage, {
        reference: reference
      });
    }
  }]);
}(_react.PureComponent);
var FlywireResultWithContext = function FlywireResultWithContext() {
  var _context$callbacks, _context$callbacks2, _context$callbacks3, _context$endpoints, _context$tenant, _context$tenant2, _context$tenant3;
  var context = (0, _react.useContext)(_PaymentContext["default"]);
  var intl = (0, _reactIntl.useIntl)();
  return _react["default"].createElement(FlywireResult, {
    intl: intl,
    onError: context === null || context === void 0 || (_context$callbacks = context.callbacks) === null || _context$callbacks === void 0 ? void 0 : _context$callbacks.onError,
    onSuccess: context === null || context === void 0 || (_context$callbacks2 = context.callbacks) === null || _context$callbacks2 === void 0 ? void 0 : _context$callbacks2.onSuccess,
    onUnverified: context === null || context === void 0 || (_context$callbacks3 = context.callbacks) === null || _context$callbacks3 === void 0 ? void 0 : _context$callbacks3.onUnverified,
    validateUrl: context === null || context === void 0 || (_context$endpoints = context.endpoints) === null || _context$endpoints === void 0 || (_context$endpoints = _context$endpoints.validateFlywirePayment) === null || _context$endpoints === void 0 ? void 0 : _context$endpoints.url,
    websiteUrls: context === null || context === void 0 || (_context$tenant = context.tenant) === null || _context$tenant === void 0 || (_context$tenant = _context$tenant.urls) === null || _context$tenant === void 0 ? void 0 : _context$tenant.website,
    primaryTextColor: context === null || context === void 0 || (_context$tenant2 = context.tenant) === null || _context$tenant2 === void 0 || (_context$tenant2 = _context$tenant2.theme) === null || _context$tenant2 === void 0 || (_context$tenant2 = _context$tenant2.colors) === null || _context$tenant2 === void 0 ? void 0 : _context$tenant2.primary,
    tenantId: context === null || context === void 0 || (_context$tenant3 = context.tenant) === null || _context$tenant3 === void 0 ? void 0 : _context$tenant3.id,
    guestSource: context === null || context === void 0 ? void 0 : context.guestSource,
    guestId: context === null || context === void 0 ? void 0 : context.guestId
  });
};
var _default = exports["default"] = FlywireResultWithContext;